/*
 * A Loading Indicator service to be used to activate the loading indicator component
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class LoadingIndicatorService {
  private indicators = 0;
  private loadingPublisher = new BehaviorSubject<boolean>(false);
  public isLoading = this.loadingPublisher.asObservable();
  private timeout;
  private readonly maxTime = 60000; //milliseconds until which all indicators will be closed
  public serverExecutionTime$ = new BehaviorSubject<string>('0');

  public setLoadingState(loading: boolean) {
    this.indicators = loading ? this.indicators + 1 : this.indicators === 0 ? this.indicators : this.indicators - 1;
    this.loadingPublisher.next(this.indicators > 0);
    if (loading) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.closeAll(), this.maxTime);
    }
  }

  public closeAll() {
    this.indicators = 0;
    this.loadingPublisher.next(false);
  }
}
